import type { FaireProductEntity } from "../../entity_types/product";

export const p_bfky7mmnn4: FaireProductEntity = {
  token: "p_bfky7mmnn4",
  type: "product",
  name: "Working Nook -- Thank You Card",
  brandToken: "b_88994016",
  brandName: "Gotamago",
  imageUrl:
    "https://cdn.faire.com/fastly/8a62ef29685244692bdd6869a3597a0121a40d9379d048bcc2f5849e494c468f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7d900f78894be5579f01371978a609deb0079746b0a08f4349ae1b940822bd36.jpeg",
    "https://cdn.faire.com/fastly/ecceb16fef5a8ab9ea206d0683399ba1f7f857982f20668f0a17964bf6817b6e.jpeg",
  ],
  priceDollars: 3,
  description:
    'Send the sweetest note of thanks from a cozy working nook. With illustrations by Isabella Lin.\n\n * A2 size (4-1/4"x 5-1/2" when folded) \n * Blank inside \n * Copper foil detailing \n * Offset printed in Toronto on natural-white, heavyweight, textured paper, and die-cut with rounded corners ',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:07.620Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
